import { spawn } from 'redux-saga/effects';

import { sagas as authenticate } from './authenticateModule';

export default function* sagas() {
	yield spawn(authenticate);
}
